import api from "./apiConfig";

export const REGISTER_FACTURA = async (data) => {
	try {
        const formData = new FormData();
		formData.append("date", data.date);
		formData.append("propertieId", data.propertieId);
		formData.append("userId", data.userId);
		formData.append("file", data.file);

        const response = await api.post("/bill", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const GET_FACTURAS = async (id) => {
	try {
		const response = await api.get(`/bill/propertie/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error al obtener las facturas:", error);
		throw error;
	}
};
